import { render, staticRenderFns } from "./AddModuleModal.vue?vue&type=template&id=03a6778b&"
import script from "./AddModuleModal.vue?vue&type=script&lang=js&"
export * from "./AddModuleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddModuleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports